import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Table, Form, Row, Col, Nav, Tab } from 'react-bootstrap';
import axios from '../../axios/axiosconf';
import html2pdf from "html2pdf-fix-jspdf";

// Importar imágenes separadas
import imgFrente from '../../../resources/img/toxina/1.png';
import imgLateral from '../../../resources/img/toxina/2.png';

const ModalToxina = ({ show, onHide, pacienteId, paciente }) => {
    // Estados principales
    const [view, setView] = useState('list'); // 'list', 'create', 'show'
    const [loading, setLoading] = useState(false);
    const [registros, setRegistros] = useState([]);

    // Estados de puntos separados
    const [puntosFrente, setPuntosFrente] = useState({ puntos: [] });
    const [puntosLateral, setPuntosLateral] = useState({ puntos: [] });

    // Pestaña activa
    const [activeTab, setActiveTab] = useState('frente');

    const [herramienta, setHerramienta] = useState('toxina'); // 'toxina', 'borrador'
    const [valorDefecto, setValorDefecto] = useState('5'); // Valor por defecto a inyectar
    const [fechaHora, setFechaHora] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [profesionalName, setProfesionalName] = useState('');

    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // Refs para obtener coordenadas
    const imgFrenteRef = useRef(null);
    const imgLateralRef = useRef(null);

    // Datos usuario
    const [userData, setUserData] = useState(null);

    // Cargar datos al abrir
    useEffect(() => {
        if (show) {
            let user = {};
            if (localStorage.getItem('userdata')) {
                user = JSON.parse(localStorage.getItem('userdata'));
                setUserData(user);
            }

            const config = { headers: { Authorization: 'Bearer ' + user.access_token } }

            // Nombre profesional
            axios.get('/perfil', config)
                .then(response => {
                    if (response.status === 200) {
                        setProfesionalName(response.data.name + ' ' + response.data.lastname);
                    }
                })
                .catch(() => setProfesionalName(`${user.name || ''} ${user.lastname || ''}`));

            // Encabezado
            axios.get('/encabezado-personalizado?uid=' + user.user_id, config)
                .then(res => { if (res.data && res.data.estado === 1) setEncabezadoPersonalizado(res.data); })
                .catch(() => setEncabezadoPersonalizado(null));

            cargarHistorial();
            setView('list');
        }
    }, [show, pacienteId]);

    const cargarHistorial = async () => {
        setLoading(true);
        try {
            const userStr = localStorage.getItem('userdata');
            const token = userStr ? JSON.parse(userStr).access_token : '';
            const config = { headers: { Authorization: `Bearer ${token}` } };

            const response = await axios.get(`/toxinas-paciente?paciente_id=${pacienteId}`, config);
            setRegistros(response.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleNuevo = () => {
        setPuntosFrente({ puntos: [] });
        setPuntosLateral({ puntos: [] });
        setObservaciones('');
        setActiveTab('frente');

        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        setFechaHora(now.toISOString().slice(0, 16));

        setView('create');
    };

    const handleVer = (item) => {
        try {
            // Cargar datos Frente (datos)
            let dataFrente = typeof item.datos === 'string' ? JSON.parse(item.datos) : item.datos;

            // Adaptar estructura antigua si es necesario
            if (dataFrente.completo) {
                setPuntosFrente({ puntos: dataFrente.completo });
                setPuntosLateral({ puntos: [] });
            } else {
                setPuntosFrente(dataFrente || { puntos: [] });
            }

            // Cargar datos Lateral (datos2)
            if (item.datos2) {
                let dataLateral = typeof item.datos2 === 'string' ? JSON.parse(item.datos2) : item.datos2;
                setPuntosLateral(dataLateral || { puntos: [] });
            } else {
                setPuntosLateral({ puntos: [] });
            }

            setFechaHora(item.fecha_hora);
            setObservaciones(item.observaciones || '');
            setProfesionalName(item.profesional_nombre || 'Desconocido');
            setView('show');
            setActiveTab('frente');
        } catch (e) {
            console.error(e);
            alert("Error al cargar datos.");
        }
    };

    const guardar = async () => {
        if (puntosFrente.puntos.length === 0 && puntosLateral.puntos.length === 0) {
            alert("No has marcado ningún punto en ninguna vista.");
            return;
        }

        setLoading(true);
        try {
            const userStr = localStorage.getItem('userdata');
            const token = userStr ? JSON.parse(userStr).access_token : '';
            const config = { headers: { Authorization: `Bearer ${token}` } };

            const payload = {
                paciente_id: pacienteId,
                fecha_hora: fechaHora,
                datos: JSON.stringify(puntosFrente), // Guardamos Frente en datos
                datos2: JSON.stringify(puntosLateral), // Guardamos Lateral en datos2
                observaciones: observaciones
            };

            await axios.post('/toxina', payload, config);
            alert("Guardado correctamente.");
            cargarHistorial();
            setView('list');
        } catch (err) {
            console.error(err);
            alert("Error al guardar.");
        } finally {
            setLoading(false);
        }
    };

    // Manejo de Clics en Imagen
    const handleImageClick = (e, tipo) => {
        if (view === 'show') return;

        const rect = e.target.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const xPerc = (x / rect.width) * 100;
        const yPerc = (y / rect.height) * 100;

        if (herramienta === 'toxina') {
            let val = valorDefecto;
            if (!val) {
                val = prompt("Ingrese cantidad de unidades:", "5");
            }
            if (!val) return;

            const nuevoPunto = {
                id: Date.now(),
                x: xPerc,
                y: yPerc,
                valor: val
            };

            if (tipo === 'frente') {
                setPuntosFrente(prev => ({ ...prev, puntos: [...prev.puntos, nuevoPunto] }));
            } else {
                setPuntosLateral(prev => ({ ...prev, puntos: [...prev.puntos, nuevoPunto] }));
            }
        }
    };

    const handlePuntoClick = (e, index, tipo) => {
        e.stopPropagation();
        if (view === 'show') return;

        if (herramienta === 'borrador') {
            if (tipo === 'frente') {
                setPuntosFrente(prev => {
                    const newList = [...prev.puntos];
                    newList.splice(index, 1);
                    return { ...prev, puntos: newList };
                });
            } else {
                setPuntosLateral(prev => {
                    const newList = [...prev.puntos];
                    newList.splice(index, 1);
                    return { ...prev, puntos: newList };
                });
            }
        }
    };

    // Renderizar Puntos
    const renderPuntos = (tipo) => {
        const puntosList = tipo === 'frente' ? puntosFrente.puntos : puntosLateral.puntos;

        return (puntosList || []).map((p, i) => (
            <div
                key={p.id || i}
                onClick={(e) => handlePuntoClick(e, i, tipo)}
                style={{
                    position: 'absolute',
                    left: `${p.x}%`,
                    top: `${p.y}%`,
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 0, 0, 0.7)',
                    border: '2px solid white',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    cursor: view === 'create' && herramienta === 'borrador' ? 'not-allowed' : 'pointer',
                    zIndex: 10
                }}
                title={`Valor: ${p.valor}`}
            >
                {p.valor}
            </div>
        ));
    };

    // Calcular total de unidades
    const calcularTotal = (tipo) => {
        const puntosList = tipo === 'frente' ? (puntosFrente.puntos || []) : (puntosLateral.puntos || []);
        return puntosList.reduce((acc, curr) => acc + (parseFloat(curr.valor) || 0), 0);
    };

    const calcularTotalGlobal = () => {
        return calcularTotal('frente') + calcularTotal('lateral');
    };

    // PDF 
    const descargarPDF = () => {
        const generarEncabezado = () => {
            if (!encabezadoPersonalizado) return '';
            const limpiarHTML = (html) => html ? html.replace(/<p>/gi, '<div style="margin:0;line-height:1.1;">').replace(/<\/p>/gi, '</div>') : '';
            return `
                <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px;">
                    <tr>
                        <td style="width: 30%; font-size: 10px;">${limpiarHTML(encabezadoPersonalizado.izquierda)}</td>
                        <td style="width: 40%; text-align: center; font-size: 11px;">${limpiarHTML(encabezadoPersonalizado.centro)}</td>
                        <td style="width: 30%; text-align: right; font-size: 10px;">${limpiarHTML(encabezadoPersonalizado.derecha)}</td>
                    </tr>
                </table>
            `;
        };

        const contenido = document.getElementById('toxina-container-print');

        const opt = {
            margin: 10,
            filename: `toxina-${pacienteId}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'landscape' }
        };

        const html = `
            <div style="font-family: Arial; padding: 20px;">
                ${generarEncabezado()}
                <h3 style="text-align:center; border-bottom: 2px solid #ccc; padding-bottom: 10px;">Aplicación Toxina Botulínica</h3>
                <div style="margin-bottom: 10px;">
                    <strong>Paciente:</strong> ${paciente.primerNombre} ${paciente.primerApellido} <br/>
                    <strong>Documento:</strong> ${paciente.numeroDocumento} <br/>
                    <strong>Fecha:</strong> ${fechaHora} <br/>
                    <strong>Unidades Frontal:</strong> ${calcularTotal('frente')} <br/>
                    <strong>Unidades Lateral:</strong> ${calcularTotal('lateral')} <br/>
                    <strong>Total Global:</strong> ${calcularTotalGlobal()}
                </div>
                <div style="text-align: center; margin-top: 20px;">
                    ${contenido.innerHTML}
                </div>
                <div style="margin-top:20px; border:1px solid #ccc; padding:10px;">
                    <strong>Observaciones:</strong><br/>
                    ${observaciones}
                </div>
            </div>
        `;

        html2pdf(html, opt);
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Toxina Botulínica {view === 'show' ? '(Histórico)' : ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflowY: 'auto', maxHeight: '80vh' }}>

                {view === 'list' && (
                    <>
                        <div className="d-flex justify-content-between mb-3">
                            <h4>Historial de Aplicaciones</h4>
                            <Button variant="success" onClick={handleNuevo}><i className="fas fa-plus"></i> Nueva Aplicación</Button>
                        </div>
                        <Table striped bordered responsive>
                            <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>Profesional</th>
                                    <th>Unid. Frontal</th>
                                    <th>Unid. Lateral</th>
                                    <th>Total</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {registros.map((r, i) => (
                                    <tr key={i}>
                                        <td>{r.fecha_hora}</td>
                                        <td>{r.profesional_nombre}</td>
                                        <td>{r.unidades_totales || 0}</td>
                                        <td>{r.unidades_totales2 || 0}</td>
                                        <td><strong>{(parseFloat(r.unidades_totales || 0) + parseFloat(r.unidades_totales2 || 0))}</strong></td>
                                        <td>
                                            <Button size="sm" variant="info" onClick={() => handleVer(r)}>Ver</Button>
                                        </td>
                                    </tr>
                                ))}
                                {registros.length === 0 && <tr><td colSpan="6" className="text-center">No hay registros.</td></tr>}
                            </tbody>
                        </Table>
                    </>
                )}

                {(view === 'create' || view === 'show') && (
                    <div id="toxina-container-print">

                        {/* 1. CONTROLES DE FECHA Y APLICACIÓN (Ahora Arriba) */}
                        {view === 'create' && (
                            <div className="card mb-3 p-3 bg-light">
                                <Row className="align-items-end">
                                    <Col md={3}>
                                        <Form.Group className="mb-0">
                                            <Form.Label>Fecha</Form.Label>
                                            <Form.Control type="datetime-local" value={fechaHora} onChange={e => setFechaHora(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-0">
                                            <Form.Label>Cantidad a Inyectar</Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={valorDefecto}
                                                onChange={e => setValorDefecto(e.target.value)}
                                                placeholder="Ej: 5"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <div className="btn-group w-100">
                                            <Button
                                                variant={herramienta === 'toxina' ? 'primary' : 'outline-primary'}
                                                onClick={() => setHerramienta('toxina')}
                                            >
                                                <i className="fas fa-syringe"></i> Aplicar
                                            </Button>
                                            <Button
                                                variant={herramienta === 'borrador' ? 'danger' : 'outline-danger'}
                                                onClick={() => setHerramienta('borrador')}
                                            >
                                                <i className="fas fa-eraser"></i> Borrar Punto
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                                <div className="text-muted mt-2 small">
                                    <i className="fas fa-info-circle"></i> Seleccione "Aplicar" y haga clic sobre la imagen. Cambie de pestaña para marcar en la otra vista.
                                </div>
                            </div>
                        )}

                        {/* 2. IMÁGENES */}
                        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                            <Nav variant="tabs" className="mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="frente"
                                        className={activeTab === 'frente' ? 'text-white bg-success' : 'text-dark bg-light'}
                                        style={{ fontWeight: 'bold', border: '1px solid #dee2e6' }}
                                    >
                                        Vista Frontal
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="lateral"
                                        className={activeTab === 'lateral' ? 'text-white bg-success' : 'text-dark bg-light'}
                                        style={{ fontWeight: 'bold', border: '1px solid #dee2e6' }}
                                    >
                                        Vista Lateral
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>

                            <Tab.Content className="text-center bg-white border p-3">
                                <Tab.Pane eventKey="frente">
                                    <div style={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
                                        <img
                                            ref={imgFrenteRef}
                                            src={imgFrente}
                                            alt="Vista Frente"
                                            style={{ maxHeight: '600px', width: 'auto', display: 'block', cursor: view === 'create' ? 'crosshair' : 'default' }}
                                            onClick={(e) => handleImageClick(e, 'frente')}
                                        />
                                        {renderPuntos('frente')}
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="lateral">
                                    <div style={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
                                        <img
                                            ref={imgLateralRef}
                                            src={imgLateral}
                                            alt="Vista Lateral"
                                            style={{ maxHeight: '600px', width: 'auto', display: 'block', cursor: view === 'create' ? 'crosshair' : 'default' }}
                                            onClick={(e) => handleImageClick(e, 'lateral')}
                                        />
                                        {renderPuntos('lateral')}
                                    </div>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>

                        {/* 3. TOTALES */}
                        <div className="alert alert-info py-2 mb-3 mt-3">
                            <div className="row text-center">
                                <div className="col-md-4">
                                    <strong>Frontal:</strong> {calcularTotal('frente')} U
                                </div>
                                <div className="col-md-4">
                                    <strong>Lateral:</strong> {calcularTotal('lateral')} U
                                </div>
                                <div className="col-md-4">
                                    <h5><i className="fas fa-calculator"></i> Total: {calcularTotalGlobal()} U</h5>
                                </div>
                            </div>
                        </div>

                        {/* 4. OBSERVACIONES */}
                        <div className="mt-3">
                            <Form.Group>
                                <Form.Label>Observaciones</Form.Label>
                                <Form.Control
                                    as="textarea" rows={3}
                                    value={observaciones}
                                    onChange={e => setObservaciones(e.target.value)}
                                    readOnly={view === 'show'}
                                />
                            </Form.Group>
                        </div>
                    </div>
                )}

            </Modal.Body>
            <Modal.Footer>
                {view !== 'list' && (
                    <Button variant="secondary" onClick={() => setView('list')}>Volver</Button>
                )}
                {view === 'create' && (
                    <Button variant="primary" onClick={guardar} disabled={loading}>Guardar</Button>
                )}
                {view === 'show' && (
                    <Button variant="danger" onClick={descargarPDF}><i className="fas fa-file-pdf"></i> PDF</Button>
                )}
                {view === 'list' && (
                    <Button variant="secondary" onClick={onHide}>Cerrar</Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ModalToxina;
